export const version = {
  numero: '1.41.1'
}
